const lungSigns = [

    {label:"Side",
    controlType:"radio button",
    options:["Right", "Left", "Bilateral"]
    },

    {label:"Inspection",
    controlType:"checkbox group",
    options:["Audible wheeze", "Poor expansion", "Paradoxical breathing", "Pectus excavatum", "Barrelling" ]
    },

    {label:"Palpation",
    controlType:"checkbox group",
    options:["chest wall nodules", "Tenderness", "Tracheal deviation", "Tactile vocal fremitus"]
    },

    {label:"Percussion",
    controlType:"checkbox group",
    options:["Hyperresonance","Basal dullness", "Upper lobe dullness", "Stoney dullness" ]
    },

    {label:"Ausculation",
    controlType:"checkbox group",
    options:["Wheeze","Stridor", "Decreased air entry","Increased vocal resonance", "Course crepitations", "Fine crepitations" ]
    },

    {label:"Any other findings",
    controlType:"text area",
    options:[]
    },
]

    export default lungSigns
